import {servicesGridStyles, serviceCardStyles, serviceIconStyles, serviceTitleStyles, serviceDescStyles, serviceFeaturesStyles, serviceFeatureStyles,  
    sectionTitleStyles, ctaSectionStyles, ctaButtonsStyles, primaryButtonStyles, secondaryButtonStyles, processGridStyles, processStepStyles, processNumberStyles, processStepTitleStyles, processStepDescStyles,   centerDescStyles, pageHeaderSubStyles, pageHeaderTitleStyles, pageHeaderStyles, sectionStyles, containerStyles} from './styles';

const ServicesPage = () => {
const services = [
   {
    icon: "🏢",
    title: "Market Entry and Business Establishment",
    description: "Complete support for establishing your legal presence in Saudi Arabia, from entity formation to operational approvals.",
    features: [
      "Legal entity establishment within 30-45 days",
      "Banking relationships and financial infrastructure setup",
      "Licensing, permits, and operational approvals",
      "Regulatory compliance across government frameworks",
      "Cultural integration and communication protocols"
    ]
  },
  {
    icon: "🤝",
    title: "Strategic Partnership Development",
    description: "Connect with vetted Saudi partners through comprehensive due diligence and structured partnership development.",
    features: [
      "Vetted Saudi partner identification and due diligence",
      "Joint venture structuring and negotiation support",
      "Partnership agreement development and legal review",
      "Partner reputation and background verification",
      "Comprehensive financial and legal due diligence"
    ]
  },
  {
    icon: "💰",
    title: "Investment and Capital Solutions",
    description: "Access investment opportunities across Vision 2030 priority sectors and connect with Saudi funding sources.",
    features: [
      "Investment matching in technology, infrastructure & energy",
      "Venture capital and angel investor connections",
      "Saudi investment fund introductions",
      "Multi-currency banking and Islamic finance solutions",
      "Early-stage funding strategy and pitch preparation"
    ]
  },
  {
    icon: "📊",
    title: "Market Intelligence and Advisory",
    description: "Stay informed with real-time market analysis, regulatory updates, and Vision 2030 strategic alignment support.",
    features: [
      "Weekly government policy and regulatory updates",
      "Sector-specific intelligence across 13 key industries",
      "Vision 2030 program identification and alignment",
      "Competitor analysis and market positioning studies",
      "Government relations and agency liaison"
    ]
  },
  {
    icon: "🌐",
    title: "Professional Networks and Business Development",
    description: "Build valuable connections through executive networking events and cross-cultural business integration support.",
    features: [
      "Access to Saudi C-suite and decision-makers",
      "Sector-specific business forums and conferences",
      "Saudi business etiquette and protocol training",
      "Private investor meetings and partnership summits",
      "Digital transformation and e-commerce localization"
    ]
  },
  {
    icon: "🚀",
    title: "Post-Entry Success and Growth",
    description: "Ongoing support for scaling operations, accessing government contracts, and achieving long-term growth in Saudi Arabia.",
    features: [
      "Performance monitoring and KPI tracking",
      "Government contract access and tender support",
      "Local talent acquisition and development",
      "Market expansion and scaling strategies",
    ]
  },
  {
    icon: "🏛️",
    title: "Government Relations and Compliance",
    description: "Navigate Saudi regulatory landscape with ongoing compliance support and government stakeholder engagement.",
    features: [
      "Regulatory compliance audits and monitoring",
      "Government stakeholder engagement sessions",
      "Contract negotiation and dispute resolution",
      "Public-private partnership (PPP) development",
      "Policy change impact assessment and adaptation"
    ]
  }
];

  const membershipTiers = [
    {
      name: "Essential",
      price: "Free",
      duration: "",
      features: [
        "Access to public events",
        "Monthly newsletter",
        "Basic networking directory",
        "Online community access"
      ]
    },
    {
      name: "Professional",
      price: "£299",
      duration: "per year",
      features: [
        "All Essential features",
        "Premium event access",
        "Market intelligence reports",
        "1-on-1 business consultations",
        "Priority partner matching"
      ],
      popular: true
    },
    {
      name: "Corporate",
      price: "£999",
      duration: "per year",
      features: [
        "All Professional features",
        "Exclusive executive events",
        "Custom market research",
        "Dedicated account manager",
        "Trade mission participation",
        "Speaking opportunities"
      ]
    }
  ];

  return (
    <div>
      {/* Page Header */}
      <section style={pageHeaderStyles}>
        <div style={containerStyles}>
          <h1 style={pageHeaderTitleStyles}>Our Services</h1>
          <p style={pageHeaderSubStyles}>
            Comprehensive solutions to facilitate business growth, partnerships, and success 
            in the Saudi-British market landscape.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section style={sectionStyles}>
        <div style={containerStyles}>
          <h2 style={sectionTitleStyles}>What We Offer</h2>
          <div style={servicesGridStyles}>
            {services.map((service, index) => (
              <div key={index} style={serviceCardStyles}>
                <div style={serviceIconStyles}>{service.icon}</div>
                <h3 style={serviceTitleStyles}>{service.title}</h3>
                <p style={serviceDescStyles}>{service.description}</p>
                <ul style={serviceFeaturesStyles}>
                  {service.features.map((feature, idx) => (
                    <li key={idx} style={serviceFeatureStyles}>{feature}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Membership Tiers */}
      {/* <section style={{...sectionStyles, backgroundColor: '#f8f9fa'}}>
        <div style={containerStyles}>
          <h2 style={sectionTitleStyles}>Membership Options</h2>
          <p style={centerDescStyles}>
            Choose the membership tier that best fits your business needs and growth objectives.
          </p>
          <div style={membershipGridStyles}>
            {membershipTiers.map((tier, index) => (
              <div key={index} style={{
                ...membershipCardStyles,
                ...(tier.popular ? popularCardStyles : {})
              }}>
                {tier.popular && <div style={popularBadgeStyles}>Most Popular</div>}
                <div style={membershipHeaderStyles}>
                  <h3 style={membershipNameStyles}>{tier.name}</h3>
                  <div style={membershipPriceStyles}>
                    <span style={priceNumberStyles}>{tier.price}</span>
                    {tier.duration && <span style={priceDurationStyles}>{tier.duration}</span>}
                  </div>
                </div>
                <ul style={membershipFeaturesStyles}>
                  {tier.features.map((feature, idx) => (
                    <li key={idx} style={membershipFeatureStyles}>{feature}</li>
                  ))}
                </ul>
                <button style={{
                  ...primaryButtonStyles,
                  ...(tier.popular ? {} : secondaryButtonStyles),
                  width: '100%',
                  marginTop: '2rem'
                }}>
                  {tier.name === 'Essential' ? 'Get Started' : 'Choose Plan'}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Process Section */}
      <section style={sectionStyles}>
        <div style={containerStyles}>
          <h2 style={sectionTitleStyles}>How We Work</h2>
          <div style={processGridStyles}>
            <div style={processStepStyles}>
              <div style={processNumberStyles}>1</div>
              <h3 style={processStepTitleStyles}>Consultation</h3>
              <p style={processStepDescStyles}>
                We start by understanding your business goals, challenges, and opportunities in the target market.
              </p>
            </div>
            <div style={processStepStyles}>
              <div style={processNumberStyles}>2</div>
              <h3 style={processStepTitleStyles}>Strategy Development</h3>
              <p style={processStepDescStyles}>
                Our experts develop a customized strategy tailored to your specific needs and market conditions.
              </p>
            </div>
            <div style={processStepStyles}>
              <div style={processNumberStyles}>3</div>
              <h3 style={processStepTitleStyles}>Implementation</h3>
              <p style={processStepDescStyles}>
                We execute the strategy through our network, partnerships, and comprehensive support services.
              </p>
            </div>
            <div style={processStepStyles}>
              <div style={processNumberStyles}>4</div>
              <h3 style={processStepTitleStyles}>Ongoing Support</h3>
              <p style={processStepDescStyles}>
                Continuous monitoring, optimization, and support to ensure long-term success and growth.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{...sectionStyles, backgroundColor: '#006C35', color: 'white'}}>
        <div style={containerStyles}>
          <div style={ctaSectionStyles}>
            <h2 style={{...sectionTitleStyles, color: 'white'}}>Ready to Expand Your Network?</h2>
            <p style={{...centerDescStyles, color: 'white', opacity: 0.9}}>
              Join hundreds of successful businesses that have grown through our network. 
              Let us help you unlock opportunities in the Saudi-British market.
            </p>
            <div style={ctaButtonsStyles}>
              <button style={{...primaryButtonStyles, backgroundColor: 'white', color: '#006C35'}}>
                Become a Member
              </button>
              <button style={{...secondaryButtonStyles, borderColor: 'white', color: 'white'}}>
                Schedule Consultation
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default ServicesPage;